import React from 'react';
import { observer } from 'mobx-react';
import { Icon } from 'components/Icon';
import { Input } from 'components/Input';
import { Select, MultiSelect } from 'components/Select';
import { SearchInput } from 'components/SearchInput';
import pageStore from 'stores/Page/Agencies/AgenciesPageStore';

import * as utils from 'Utils';
import * as constants from 'Constants';
import './styles.scss';


@observer
class AgenciesFilter extends React.Component {
  constructor (props) {
    super(props);
  }

  render() {
    return (
        <div className="agencies-filter">
          <div className="agencies-filter-row">
            <div className="agencies-filter-label">Search</div>
            <SearchInput
              onChange={(value) => this.props.handleKeywordFilter(value)}
              value={pageStore.paramKeyword || ''}
            />
          </div>

          <div className="agencies-filter-row">
            <div className="agencies-filter-label">Price Range</div>
            <div className="agencies-price-range-group">
              <Input
                className="agencies-price-range-input"
                type="number"
                value={pageStore.paramMinPrice || ''}
                placeholder="Min Price"
                onChange={(value) => this.props.handleFilter({"paramMinPrice": value})}
                min="0"
                step="10"
              />

              <Input
                className="agencies-price-range-input"
                type="number"
                value={pageStore.paramMaxPrice || ''}
                placeholder="Max Price"
                onChange={(value) => this.props.handleFilter({"paramMaxPrice": value})}
                min="0"
                step="10"
              />
            </div>
          </div>

          <div className="agencies-filter-row">
            <div className="agencies-filter-label">Country</div>
            <MultiSelect
              placeholder="Select countries"
              value={pageStore.paramCountries.slice()}
              options={pageStore.countrySelectOptions}
              onChange={(values) => this.props.handleFilter({"paramCountries": values})}
            />
          </div>

          <div className="agencies-filter-row">
            <div className="agencies-filter-label">Language</div>
            <MultiSelect
              placeholder="Select languages"
              value={pageStore.paramLanguages.slice()}
              options={pageStore.languageSelectOptions}
              onChange={(values) => this.props.handleFilter({"paramLanguages": values})}
            />
          </div>

          <div className="agencies-filter-row">
            <div className="agencies-filter-label">Speciality</div>
            <MultiSelect
              placeholder="Select specialities"
              value={pageStore.paramSpecialities.slice()}
              options={pageStore.specialitySelectOptions}
              onChange={(values) => this.props.handleFilter({"paramSpecialities": values})}
            />
          </div>

          <div className="agencies-filter-row">
            <div className="agencies-filter-label">Platform</div>
            <MultiSelect
              placeholder="Select platforms"
              value={pageStore.paramPlatforms.slice()}
              options={pageStore.platformSelectOptions}
              onChange={(values) => this.props.handleFilter({"paramPlatforms": values})}
            />
          </div>
        </div>

    );
  }
}

export default AgenciesFilter;
